import React from 'react';
import { useIsEmbeddedMobile } from '../../../_hooks/useIsEmbeddedMobile';
import { PerformanceMobile } from './components/PerformanceMobile/PerformanceMobile';
import { DesktopWidgets } from '../../components/DesktopWidgets/DesktopWidgets';
import { TabSlug } from '../../types';

export const Performance = () => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  if (isEmbeddedMobile) {
    return <PerformanceMobile />;
  }

  return <DesktopWidgets tab={TabSlug.Performance} />;
};
